import * as _ from 'lodash-es';
// We needed to create our own app context store
// As currently AEM this.childComponents is an inmutable object
// and there is no documentation on how to pass props.
// The context values passed are constant so approach doesn't go against
// React philosophy

export default class initSecContext {
	static context = {
		propsContext: null,
		GlobalCar: null,
	};

	static tableContext = {
		prepTable: null,
		comparsionUpdate: null,
		initUpdatesCalled: 0,
		cancelTracker: null,
		comparableProducts: [],
		sections: [], // app sections handle
		lookUpByProductPath: {
			pathArr: [],
		},
		sectLookUpObj: {},
	};

	static componentInfo = {};

	static setBtnInfo(passedBtnInfo, componentId) {
		let {
			verifyBtnLabel,
			verifyTextMssg,
			veryfyURL,
			signinBtnLabel,
			signinTextMssg,
			signinURL,
			scnBtnLabel,
			scnTextMssg,
			scnURL,
			loginToSeePriceBtnLabel,
			loginToSeePriceTextMssg,
			loginToSeePriceURL,
		} = passedBtnInfo;
		let cardBtnlogic = {
			verificationMessage: {
				btnLabel: verifyBtnLabel,
				linkMssg: verifyTextMssg,
				linkUrl: veryfyURL,
			},
			logIntoVerifyMessage: {
				btnLabel: signinBtnLabel,
				linkMssg: signinTextMssg,
				linkUrl: signinURL,
			},
			selectCustomerNumberMessage: {
				btnLabel: scnBtnLabel,
				linkMssg: scnTextMssg,
				linkUrl: scnURL,
			},
			logIntoSeePriceMessage: {
				btnLabel: loginToSeePriceBtnLabel,
				linkMssg: loginToSeePriceTextMssg,
				linkUrl: loginToSeePriceURL,
			},
		};
		this.componentInfo[componentId] = cardBtnlogic;
	}

	static getBtnInfo(componentId) {
		return this.componentInfo[componentId];
	}

	static setPropsContext(context) {
		this.context.propsContext = context;
	}

	static getPropsContext() {
		return this.context.propsContext;
	}

	static setComparableProducts(comparableProducts) {
		this.tableContext.comparableProducts = comparableProducts;
		// update Comparable products
		this.tableContext.sections.forEach((sec) => {
			// sec represents each react section on the page
			sec.setComparableProducts(comparableProducts);
		});
	}

	static getComparableProducts() {
		return this.tableContext.comparableProducts;
	}

	static clearPropsContext() {
		this.context.propsContext = {};
	}

	static setGlobalCar(Car) {
		this.context.GlobalCar = Car;
	}

	static getGlobalCar() {
		return this.context.GlobalCar;
	}

	static getTableContext() {
		return this.tableContext;
	}

	static updateTableContext(newObj) {
		let tempTContext = this.tableContext;
		this.tableContext = _.assign(tempTContext, newObj);
	}

	static setPretTableCallBack(callback) {
		this.tableContext.prepTable = callback;
	}

	static prepTableUpdate(tableUpdate, section) {
		// check if all sections have called initial update
		let currPathArr = this.tableContext.lookUpByProductPath.pathArr;
		let newPaths = tableUpdate.lookUpByProductPath.pathArr;
		this.setSectionLookUp(tableUpdate.lookUpByProductPath, section);
		if (this.tableContext.initUpdatesCalled + 1 == this.context.propsContext.totalSections) {
			let fullUpdate = tableUpdate;
			fullUpdate.lookUpByProductPath = _.assign(fullUpdate.lookUpByProductPath, this.tableContext.lookUpByProductPath);
			fullUpdate.lookUpByProductPath.pathArr = _.concat(currPathArr, newPaths);

			this.tableContext.comparableProducts[tableUpdate.order] = tableUpdate.comparableProducts;
			fullUpdate.comparableProducts = [];
			this.tableContext.comparableProducts.forEach((secArr) => {
				secArr.forEach((card) => {
					fullUpdate.comparableProducts.push(card);
				});
			});
			this.tableContext.comparableProducts = fullUpdate.comparableProducts;
			this.updateStandaloneTable(fullUpdate);
		} else {
			let currLookup = this.tableContext.lookUpByProductPath;
			this.tableContext.initUpdatesCalled++;
			this.tableContext.lookUpByProductPath = _.assign(currLookup, tableUpdate.lookUpByProductPath);
			this.tableContext.lookUpByProductPath.pathArr = _.concat(currPathArr, newPaths);
			this.tableContext.comparableProducts[tableUpdate.order] = tableUpdate.comparableProducts;
		}
	}

	static ribbonActiveComparison(activeId) {
		let section = this.tableContext.sectLookUpObj[activeId];
		section.handleProdCompare([activeId]);
	}

	static setSectionLookUp(lookupObj, section) {
		let lookupArr = lookupObj.pathArr;
		lookupArr.forEach((card) => {
			this.tableContext.sectLookUpObj[lookupObj[card]] = section;
		});
		// add sections arr for cancel actions
		if (this.tableContext.sections.length === 0) {
			this.tableContext.sections.push(section);
		} else {
			let secExist = false;
			this.tableContext.sections.forEach((sec) => {
				if (sec.initSecContext.productId == section.initSecContext.productId) {
					secExist = true;
				}
			});
			if (!secExist) {
				this.tableContext.sections.push(section);
			}
		}
	}

	static updateStandaloneTable(tableUpdate) {
		this.tableContext.prepTable(tableUpdate);
	}

	static setComparsionUpdate(callback) {
		this.tableContext.comparsionUpdate = callback;
	}

	static comparisonTriggered(update) {
		let currCompProds = this.tableContext.comparableProducts;
		let compProducts = [];
		update.comparableProducts.forEach((prod) => {
			currCompProds.forEach((secProd) => {
				if (secProd.id == prod.id) {
					compProducts = [...compProducts, prod];
				}
			});
		});
		let updateLoad = {
			compTableActive: update.compTableActive,
			comparableProducts: compProducts,
		};
		// check if callback is triggered programatically by cancel function
		// this.tableContext.comparableProducts = currCompProds;
		if (this.tableContext.cancelTracker !== null && this.tableContext.cancelTracker < this.tableContext.sections.length - 1) {
			this.handleCancelActionInProgress();
			return;
		} else if (this.tableContext.cancelTracker == this.tableContext.sections.length - 1) {
			this.tableContext.cancelTracker = null;
		}

		// update table state
		this.tableContext.comparsionUpdate(updateLoad);
	}

	static handleCancelComparions() {
		// update the comparison state of each individual component
		let tracker = this.tableContext.cancelTracker;
		if (tracker == null) {
			tracker = 0;
		} else {
			tracker++;
		}
		let currSection = this.tableContext.sections[tracker];
		this.tableContext.cancelTracker = tracker;
		currSection.handleCancelComparions();
	}

	static handleCancelActionInProgress() {
		this.handleCancelComparions();
	}
}
